module.exports = __webpack_public_path__ + "static/media/bar.58124330.svg";